import './config';
import { Session } from './session';

export const session = new Session();
